import { HashLink } from 'react-router-hash-link';

const leftTimeline = [
  {
    title: 'Week 1 - Week 6',
    subtitle: 'Understanding Technical Analysis',
    content:
      'Understanding Market Structure, Candlesticks, Technical Theories, Trading Masterclass, Indicators, Trend Indicators, Momentum Indicators, Volatility Indicators, and Volume Profile',
  },
  {
    title: 'Week 8 - Week 12',
    subtitle: 'Options Strategies',
    content:
      'Options Trading, Introduction to Derivatives, Learning Options Greeks, Options Strategies, Implied Move and Volatility, Max Pain Theory and Trading Rules',
  },
  {
    title: 'Week 17 - Week 25',
    subtitle: 'Understanding Trading Strategies',
    content:
      'Trading Strategies and time Frames, Ingredients of our Trading Setups, Relative Strength Index Demystified, Trading Masterclass, Breakout Strategy, Contrarian Strategy, and PullBack Strategy',
  },
  {
    title: "Access to It's All About The Options App",
    subtitle: '',
    content:
      "Access to It's All About The Options App, our community of diverse traders, where you can discuss ideas and strategies with peers and domain experts. It's the perfect platform to level up your networking with other traders.",
  },
];

const rightTimeline = [
  {
    title: 'Week 7',
    subtitle: 'Defining Sequencing, Dark Pool Rules, and ITM Flow Theory',
    content: 'Sequencing Theory, Dark Pool Prints and ITM Flow Theory Masterclass',
  },
  {
    title: 'Week 13 - Week 16',
    subtitle: 'Mastering Currency & Commodity Trading',
    content:
      'Crypto Basic Concepts, Basics of Derivatives, Profitable Bitcoin and Crude Oil Trading Strategies, Commodity Fundamental including Gold, Silver + Crude Oil and Natural Gas, Trading Strategy.',
  },
  {
    title: 'Coaching',
    subtitle: '',
    content:
      "One-on-one interaction with the mentors and wrapping the program by sharing each other's learnings.",
  },
];

const TimelineItem = ({ title, subtitle, content, light = false }) => (
  <div className={`relative mb-8 border-l pl-6 last:mb-0 ${light ? 'border-[#6756FE]/30' : 'border-indigo-600'}`}>
    <div
      className={`absolute -left-[9px] top-1 h-4 w-4 rounded-full border-2 ${
        light
          ? 'border-[#6756FE] bg-white shadow-sm shadow-[#6756FE]/30'
          : 'border-indigo-500 bg-black'
      }`}
    />
    <h4 className={`text-sm font-semibold ${light ? 'text-[#6756FE]' : 'text-indigo-400'}`}>{title}</h4>
    {subtitle ? (
      <h3 className={`mb-2 text-base font-bold ${light ? 'text-slate-900' : 'text-white'}`}>{subtitle}</h3>
    ) : null}
    <p className={`text-sm leading-relaxed ${light ? 'text-slate-600' : 'text-gray-300'}`}>
      {content}
    </p>
  </div>
);

const JourneyTimeline = ({ variant = 'classic', contactHash = '/#contact' } = {}) => {
  if (variant === 'v2') {
    return (
      <section className="relative overflow-hidden bg-[#f8f7fc] py-20 sm:py-28">
        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(103,86,254,0.07),transparent_55%)]" />
        <div className="relative mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
          <div className="mx-auto max-w-2xl text-center">
            <p className="text-xs font-bold tracking-[0.3em] text-[#6756FE] uppercase">Curriculum</p>
            <h2 className="mt-3 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
              Your journey for the next 6 months
            </h2>
            <p className="mt-4 text-slate-500">
              Dive deep into trading concepts, build practical skills, and gain confidence — week by week.
            </p>
          </div>

          <div className="mt-12 grid gap-6 md:grid-cols-2 md:gap-8">
            <div className="rounded-3xl border border-slate-200/80 bg-white p-6 shadow-lg shadow-slate-200/40 sm:p-8">
              {leftTimeline.map((item, idx) => (
                <TimelineItem key={idx} {...item} light />
              ))}
            </div>
            <div className="rounded-3xl border border-slate-200/80 bg-white p-6 shadow-lg shadow-slate-200/40 sm:p-8">
              {rightTimeline.map((item, idx) => (
                <TimelineItem key={idx} {...item} light />
              ))}
              <div className="mt-8 flex flex-col gap-3 sm:flex-row">
                <HashLink
                  smooth
                  to={contactHash}
                  className="flex-1 rounded-full bg-[#6756FE] py-3 text-center text-sm font-bold text-white shadow-lg shadow-[#6756FE]/25 transition hover:bg-[#5646e8]"
                >
                  Contact Us
                </HashLink>
                <a
                  href="https://wa.me/+13034725428"
                  target="_blank"
                  rel="noreferrer"
                  className="flex-1 rounded-full bg-emerald-500 py-3 text-center text-sm font-bold text-white shadow-lg shadow-emerald-500/25 transition hover:bg-emerald-600"
                >
                  WhatsApp Us
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="bg-[#0e0e11] text-white py-20 px-4 md:px-20">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-center text-3xl md:text-4xl font-bold mb-4">
          Your Journey for the next 6 Months
        </h2>
        <p className="text-center text-gray-400 mb-16 max-w-3xl mx-auto">
          Over the next 6 months, you'll dive deep into various trading concepts, develop practical skills,
          and gain confidence in your trading abilities.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          <div>
            {leftTimeline.map((item, idx) => (
              <TimelineItem key={idx} {...item} />
            ))}
          </div>
          <div>
            {rightTimeline.map((item, idx) => (
              <TimelineItem key={idx} {...item} />
            ))}
            <div className="mt-10 flex flex-col sm:flex-row gap-4">
              <HashLink
                smooth
                to={contactHash}
                className="btn text-center flex-1 bg-indigo-500 hover:bg-indigo-600 text-white py-3 px-4 rounded-lg font-semibold shadow"
              >
                Contact Us
              </HashLink>
              <a
                href="https://wa.me/+13034725428"
                target="_blank"
                className="text-center flex-1 bg-green-500 hover:bg-green-600 text-white py-3 px-4 rounded-lg font-semibold shadow"
                rel="noreferrer"
              >
                WhatsApp Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default JourneyTimeline;
